import React, { useEffect, useState } from 'react'
//import { Link } from 'react-router-dom';
import { GET, DELETE, POST } from '../../../helpers/httphelper';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { toast as superToast } from 'bulma-toast'

function AllUsers() {

    const [user, setUser] = useState([])
    const [keyword, setKeyword] = useState('')


    useEffect(() => {
        GetAll()

    }, [])

    const GetAll = () => {
        GET(`api/user/all`).then((data) => {
            setUser(data)
            console.log(data)
        }).catch((err) => {
            console.log(err)
        })
    }




    // Delete patients
    const DeleteUser = (id) => {
        DELETE(`api/user/delete/${id}`).then((dat) => {
            superToast({
                message: "User Deleted successfully",
                type: 'is-danger',
                dismissible: true,
                position: "top-center",
                animate: { in: 'fadeIn', out: 'fadeOut' },
            })
            GetAll()
        }).catch((err) => {
            console.log(err)
        })


    }


    const searchfromKeyword = () => {
        const ob = {
            keyword,

        }
        POST("api/user/searchkey", ob).then(data => {
            setUser(data)
        }).catch(err => {
            console.log(err)
        })
    }

    const reset = () => {
        GetAll()
    }

    const generateReport = () => {
        // const doc = new jsPDF()
        // autoTable(doc, { html: '#table1' })
        // doc.save('table.pdf')

        const doc = new jsPDF("landscape")
        let data = []

        user.forEach((element, index, array) => {
            data.push([element.fname, element.lname, element.email, element.nic, moment(element.birth).format("YYYY-MM-DD"), element.age, element.gender, element.mobile])
        })

        doc.text(140, 10, "Patient's List");
        autoTable(doc, {
            head: [['First Name', 'Last Name', 'Email', 'NIC', 'DOB', 'Age', 'Gender', 'Contact Number']],
            body: data,


        })


        doc.save('UserList.pdf')
    }

    return (

        <section className="hero is-fullheight-with-navbar home-div">
            <div className="hero-body">
                <div className="container" style={{ overflow: 'auto' }}>
                    <div className="card has-background-grey-light" >
                        <div className="card-content" >
                            <div className=''>
                                <h1 className='title is-2 has-text-centered'>Patients List</h1>
                                <div className='field mb-1 is-flex is-justify-content-center'>
                                    <div className="field has-addons  ">
                                        <div className="control">
                                            <input className="input" type="text" onChange={(e) => { setKeyword(e.target.value) }} placeholder="Search Patients By key" />
                                        </div>
                                        <div className="control">
                                            <div className="button is-info" onClick={(e) => { searchfromKeyword() }}>
                                                <i className="fas fa-search"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='is-justify-content-center is-flex'>
                                    <div style={{
                                        overflow: 'scroll',
                                        height: '50vh',
                                    }} >

                                        <table className="table is-striped is-bordered">
                                            <thead>
                                                <tr>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th>Email</th>
                                                    <th>NIC</th>
                                                    <th>DOB</th>
                                                    <th>Age</th>
                                                    <th>Gender</th>
                                                    <th>Contact Number</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {user?.map((person, key) =>
                                                    <tr key={key}>
                                                        <td>{person.fname}</td>
                                                        <td>{person.lname}</td>
                                                        <td>{person.email}</td>
                                                        <td>{person.nic}</td>
                                                        <td>{person.birth ? person.birth.split('T')[0] : 'N/A'}</td>
                                                        <td>{person.age}</td>
                                                        <td>{person.gender}</td>
                                                        <td>{person.mobile}</td>
                                                        <td>
                                                            <button className="button is-danger"
                                                                onClick={() => { if (window.confirm('Are you sure  delete a User?')) DeleteUser(person._id) }}
                                                            >
                                                                Remove
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <button className="button is-success is-right mr-2" onClick={(e) => { generateReport() }}> Get Report</button>

                                <button className="button is-success is-right" onClick={(e) => { reset() }} > Reset</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >


    )

}

export default AllUsers